import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class VisualSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = {
      primary: this.dom.el.querySelector('[data-slide="primary"] [data-js="visual-slide"]'),
      secondary: this.dom.el.querySelector('[data-slide="secondary"] [data-js="visual-slide"]'),
      third: this.dom.el.querySelector('[data-slide="third"] [data-js="visual-slide"]'),
      fourth: this.dom.el.querySelector('[data-slide="fourth"] [data-js="visual-slide"]'),
    }
    this.dom.slides = this.dom.slider.primary.querySelectorAll('.splide__slide');

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);
    this.nextSlide = this.nextSlide.bind(this);

    this.jump = 0;

    this.slider = {
      primary: null,
      secondary: null,
      third: null,
      fourth: null,
    }

    this.option = {
      primary: {
        autoplay: true,
        // autoWidth: true,
        // focus: 'center',
        type: 'loop',
        rewind: true,
        perPage: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
        drag: false,
        interval: 5000,
        speed: 2000,
        arrows: false,
        pagination: false,
        easing: 'cubic-bezier(0, 0.4, 0.2, 1)',
        // gap: `${20 / 375 * 100}%`,
      }
    };


    this.option.secondary = Object.assign({}, this.option.primary);
    this.option.secondary.start = 1;

    this.option.third = Object.assign({}, this.option.primary);
    this.option.third.start = this.dom.slides.length - 1;
    
    this.option.fourth = Object.assign({}, this.option.primary);
    this.option.fourth.start = (window.innerWidth < 768) ? 1 : 2;

    this.init();
  }

  init() {

    this.slider.primary = new Splide(this.dom.slider.primary, this.option.primary);
    this.slider.primary.mount();

    this.slider.secondary = new Splide(this.dom.slider.secondary, this.option.secondary);
    this.slider.secondary.mount();

    this.slider.third = new Splide(this.dom.slider.third, this.option.third);
    this.slider.third.mount();

    this.slider.fourth = new Splide(this.dom.slider.fourth, this.option.fourth);
    this.slider.fourth.mount();

    // ブレイクポイントの瞬間に発火
    this.mql.addListener(this.checkBreakPoint);
    // 初回チェック
    this.checkBreakPoint(this.mql);
  }

  nextSlide() {
    this.dom.progressAnimation.dataset.anim = 'end';
    this.progress = !this.progress;
    this.slider.go('>');
  }

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');

      if (this.slider.fourth) {
        this.slider.fourth.destroy();
        this.slider.fourth = null;
      }

      this.slider.primary.refresh();
      this.slider.secondary.refresh();
      this.slider.third.refresh();
      
      return;
    } else {
      // console.log('pc');
      
      if (!this.slider.fourth) {
        this.option.fourth.start = this.slider.primary.index;
        this.slider.fourth = new Splide(this.dom.slider.fourth, this.option.fourth);
        this.slider.fourth.mount();
      }
      this.option.fourth.start = 2;

      this.slider.primary.refresh();
      this.slider.secondary.refresh();
      this.slider.third.refresh();
      
      const { Move } = this.slider.fourth.Components;
      this.jump = this.slider.primary.index + 2;
      Move.jump(this.jump);
      this.slider.fourth.go(this.slider.primary.index + 2);

      return;
		}
	}
}

export default VisualSlides